module App.State

open Elmish
open Fable.Core.JsInterop
open Fable.PowerPack
open Model
open Messages

let getDialects _ =
    promise {
        let url = "api/dialects"
        return! Fetch.fetchAs<obj []> url []
    }

let loadDialectListCmd =
    Cmd.ofPromise getDialects [] FetchedDialects FetchError

let getWordlist dialectId =
    promise {
        let url = sprintf "api/dialects/%s/words" dialectId
        return! Fetch.fetchAs<obj []> url []
    }

let loadWordListCmd msg dialectId =
    if dialectId = "" then Cmd.none
    else Cmd.ofPromise getWordlist dialectId msg FetchError

let downloadWordlist dialectId =
    promise {
        let url = sprintf "api/dialects/%s/download" dialectId
        return! Fetch.fetch url [] |> Promise.bind (fun response -> response.text())
    }

let downloadWordListCmd dialectId =
    if dialectId = "" then Cmd.none
    else Cmd.ofPromise downloadWordlist dialectId DownloadedWordlist FetchError

let sortWords (sortArg: Fable.Import.ReactVirtualized.SortArg) words =
    let compareFn x y = 
        if sortArg.SortDirection = "ASC" then (compare x y) else (compare y x)

    let sortFn word1 word2 = 
        let val1 = string word1?(sortArg.SortBy)
        let val2 = string word2?(sortArg.SortBy)
        if sortArg.SortBy = "freq" then compareFn (int val1) (int val2)
        else compareFn val1 val2

    Array.sortWith sortFn words

let init _ =
    { Dialects = [||]
      SelectedDialectId1 = ""
      SelectedDialectId2 = ""
      Words1 = [||]
      Words2 = [||]
      WordFilter1 = ""
      WordFilter2 = ""
      WordTableSort1 = { SortBy = "freq"; SortDirection = "DESC"} 
      WordTableSort2 = { SortBy = "freq"; SortDirection = "DESC"} },
    loadDialectListCmd

let update msg model =
  match msg with
  | FetchError exn ->
      printfn "%s" exn.Message
      model, Cmd.none
  | FetchedDialects dialects ->
      { model with Dialects = dialects }, Cmd.none
  | SelectedDialect1Changed dialectId ->
      { model with SelectedDialectId1 = dialectId }, loadWordListCmd FetchedWordlist1 dialectId
  | SelectedDialect2Changed dialectId ->
      { model with SelectedDialectId2 = dialectId }, loadWordListCmd FetchedWordlist2 dialectId
  | FetchedWordlist1 words ->
      { model with Words1 = sortWords model.WordTableSort1 words }, Cmd.none
  | FetchedWordlist2 words ->
      { model with Words2 = sortWords model.WordTableSort2 words }, Cmd.none
  | WordFilter1Changed input ->
      { model with WordFilter1 = input}, Cmd.none
  | WordFilter2Changed input ->
      { model with WordFilter2 = input}, Cmd.none
  | DownloadWordlist1 dialectId ->
      model, downloadWordListCmd dialectId
  | DownloadWordlist2 dialectId ->
      model, downloadWordListCmd dialectId
  | DownloadedWordlist fileName ->
      Fable.Import.Browser.window.``open``(fileName) |> ignore
      model, Cmd.none
  | SetWordTableSort1 sortArg ->
      let sortedWords = sortWords sortArg model.Words1
      { model with WordTableSort1 = sortArg; Words1 = sortedWords }, Cmd.none
  | SetWordTableSort2 sortArg ->
      let sortedWords = sortWords sortArg model.Words2
      { model with WordTableSort2 = sortArg; Words2 = sortedWords }, Cmd.none


// WEBPACK FOOTER //
// src/State.fs